// @flow

import * as React from 'react';
import { Box, Meter, Text } from 'grommet';
import styled from 'styled-components';
import SidePaneContext from './layout/context/SidePaneContext';

type Props = {
    ...React.ElementProps<typeof Meter>,
    color?: string,
    textColor?: string,
    background?: string,
    label: React.Node,
    description: React.Node,
    progress: number,
    index: number,
    error: boolean,
    hasOpenedPanels: boolean,
}

const PositionContainer = styled(Box)`
    position: fixed;
    left: 60px;
    bottom: ${(props) => props.positionBottom}px;
    right: ${(props) => props.right}px;
    overflow: visible;
    z-index: 999;
`;

const StyledMeter = styled(Meter)`
    width: 100%;
`;

const ProgressBarLabelContainer = styled(Box)`
    position: absolute;
    bottom: 4px;
    left: 10px;
    z-index: 1000;
`;

const ProgressBar = (props: Props) => {
    const {
        background, label, description, progress, color, index, textColor, error, hasOpenedPanels, ...rest
    } = props;

    const { size } = React.useContext(SidePaneContext);

    return (
        <PositionContainer positionBottom={index * 24} right={hasOpenedPanels ? size : 0}>
            <StyledMeter
                max={100}
                background={background}
                values={[{
                    value: error ? 100 : progress,
                    color: error ? 'status-error' : color,
                    highlight: true,
                }]}
                {...rest}
            />
            <ProgressBarLabelContainer>
                <Text color={error ? '#fff' : textColor}>
                    {`${label} ${error ? '' : `(${progress.toFixed(2)}%)`}${description
                        ? `: ${description}` : ''}`}
                </Text>
            </ProgressBarLabelContainer>
        </PositionContainer>
    );
};

ProgressBar.defaultProps = {
    color: 'blue',
    textColor: '',
    background: '#cbcbcb',
    index: 0,
};

export default ProgressBar;
